export const CREATE_OFFLINE_INVESTOR_ATTEMPT = 'CREATE_OFFLINE_INVESTOR_ATTEMPT';
export type CREATE_OFFLINE_INVESTOR_ATTEMPT = typeof CREATE_OFFLINE_INVESTOR_ATTEMPT;

export const CREATE_OFFLINE_INVESTOR_SUCCESS = 'CREATE_OFFLINE_INVESTOR_SUCCESS';
export type CREATE_OFFLINE_INVESTOR_SUCCESS = typeof CREATE_OFFLINE_INVESTOR_SUCCESS;

export const CREATE_OFFLINE_INVESTOR_FAILURE = 'CREATE_OFFLINE_INVESTOR_FAILURE';
export type CREATE_OFFLINE_INVESTOR_FAILURE = typeof CREATE_OFFLINE_INVESTOR_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/offline-investor/create/Types.tsx